module.exports = __webpack_public_path__ + "assets/images/red1_33e827d8a20bdfe2ccb39f4550813c00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/red1.png
// module id = 155
// module chunks = 0